import * as angular from 'angular';

const events = {
  reloadTransactionList: 'reload-transaction-list'
};

const types = [
  'PerTransaction',
  'PerTransactionInvoiceMonthly',
  'PerTransactionPerioidicInvoice',
  'DebitThreshold',
  'Manual'
];

const chargingTerms = [
  'DueOnReceipt',
  'Net10',
  'Net15',
  'Net30',
  'Net60'
]

const paymentMethods = [
  {
    title: 'Cash',
    value: 'cash'
  },
  {
    title: 'Bank Transfer',
    value: 'bank'
  },
  {
    title: 'Cheque',
    value: 'cheque'
  },
  {
    title: 'Credit Card',
    value: 'creditCard'
  }];

const cardTypes = [
  'Visa',
  'Cal',
  'Diners',
  'American Express',
  'Isracard',
  'Mastercard'
];


angular
  .module('bringoz.admin.billing-accounts')
  .constant('billingAccountConstants', {
    events : events,
    types : types,
    paymentMethods: paymentMethods,
    cardTypes: cardTypes,
    chargingTerms:chargingTerms
  });
